import React, { useContext } from 'react';
import { Button, Dropdown } from 'antd';
import PropTypes from 'prop-types';
import { ApplicationUIContext } from '../Provider/Provider';

const doNothing = () => {};

const renderButtons = (buttons, { isMobile }) =>
  buttons.map((button, index) => {
    if (React.isValidElement(button)) {
      return button;
    }
    const { label, onClick = doNothing, ...buttonProps } = button;

    return (
      <Button
        key={`${label}.${index}`}
        onClick={onClick || doNothing}
        {...buttonProps}
        size={isMobile && 'large'}
      >
        {label}
      </Button>
    );
  });

const ButtonGroup = ({ buttons = [], dropdownOverlay }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const buttonsToRender = dropdownOverlay ? buttons.slice(0, -1) : buttons;
  const lastButton = buttons[buttons.length - 1];

  if (!lastButton) {
    return null;
  }

  return (
    <div className="ant-btn-group" style={{ flexWrap: 'wrap', rowGap: 16 }}>
      {renderButtons(buttonsToRender, { isMobile })}

      {dropdownOverlay ? (
        <Dropdown.Button
          overlay={dropdownOverlay}
          trigger={['click']}
          size={isMobile && 'large'}
          onClick={lastButton.onClick}
        >
          {lastButton.label}
        </Dropdown.Button>
      ) : null}
    </div>
  );
};

ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        type: PropTypes.string,
        onClick: PropTypes.func.isRequired,
      }),
    ])
  ),
  dropdownOverlay: PropTypes.node,
};

export { ButtonGroup };
